export default __webpack_public_path__ + "static/media/cec0d3b07580b400e1cd1a67992f7aec.svg";